export default __webpack_public_path__ + "static/media/logoMobile.9a1e3633.png";